<template>
    <div 
        :id="$formatId(slice.id)" 
        class="container"
        :class="{'content-space-t-1': isFirstSlice}"
    >
        <list-header-with-disclosure 
            :h2="h2.replace('%count%', lendersCount)" 
            :show-important-disclosure="showImportantDisclosure" 
            :is-first-slice="isFirstSlice"
        />

        <filter-form 
            v-if="slice.primary.include_filter_box" 
            :filter-data="userFilter" 
            :list-length="listToShow.length" 
            :active-filters-length="activeFilters.length" 
            :unfiltered-list-length="listToFilter.length"
            :hide-filter-amount-slider="slice.primary.hide_filter_amount_slider"
            :filter-amount-text="slice.primary.filter_amount_text"
        />
        <div class="row">
            <lender-card 
                v-for="(lender, index) in topList" 
                :key="lender.id" 
                :lender-id="lender.id" 
                :position="index + 1"
                :alternate-data-config="alternateDataConfig"
                :fixed-amount="amountFromSlice"
            />
        </div>
        <div v-show="showAll" class="row">
            <lender-card 
                v-for="(lender, index) in notShownList" 
                :key="lender.id" 
                :lender-id="lender.id"
                :position="topList.length + index + 1"
                :alternate-data-config="alternateDataConfig"
                :fixed-amount="amountFromSlice"
            />
        </div>
        <CommercialDisclaimer />
        <div 
            v-show="!showAll && notShownList.length > 0" 
            class="col-lg-12 text-sm text-dark"
        >
            <div class="text-center mt-4 mb-4">
                <a class="btn btn-md btn-secondary fw-bold" @click="showAllLenders()">
                    {{ $translate('show_all_lenders', 'Visa alla långivare') }} <i class="bi bi-arrow-down-circle-fill ms-2" />
                </a>
            </div>
        </div>
        <structured-data 
            v-if="slice.primary.include_statistics_table || slice.primary.include_comparisons_table"
            :slice="slice"
            :list="listToShow" 
            :alternate-data-config="alternateDataConfig"
        />
        <loan-wizard-intro 
            v-if="slice.primary.include_loan_wizard_intro"
            :teaser="slice.primary.loan_wizard_intro_teaser"
            two-columns
            class="my-5"
        />
    </div>
</template>
<script>
import LenderCard from '@/components/cards/LenderCard.vue';
import CommercialDisclaimer from '@/components/CommercialDisclaimer.vue';
import FilterForm from '@/components/filter/FilterForm.vue';
import StructuredData from '@/components/structuredData/index.vue';
import LoanWizardIntro from '@/components/LoanWizardIntro.vue';
import ListHeaderWithDisclosure from '@/components/ListHeaderWithDisclosure.vue';

import FilterLogic from '@/components/filter/FilterLogic.js'; 

export default {
    components: {
        LenderCard,
        CommercialDisclaimer,
        FilterForm,
        StructuredData,
        LoanWizardIntro,
        ListHeaderWithDisclosure
    },
    mixins: [FilterLogic],
    data() {
        return {
            showAll: false,
            lendersToShow: 12,
        };
    },

    computed: {
        listToShow() {
            if (this.slice.primary.include_filter_box) {
                return this.filterOutNotEnabledLenders(this.filteredList);
            }
            return this.filterOutNotEnabledLenders(this.list);
        },
        topList() {

            if (this.count) {
                return this.listToShow.slice(0, this.count);
            }

            return this.listToShow.slice(0, this.lendersToShow);
        },
        notShownList() {

            if (this.count) {
                return [];
            }

            return this.listToShow.slice(this.lendersToShow);
        },
        lendersCount() {
            if (this.count) {
                return this.count;
            }
            
            return this.list.length;
        },
        alternateDataConfig() {
            return this.$getAlternateDataConfig(this.slice);
        },
        alternateDataKeys() {
            return this.$getAlternateDataKeys(this.alternateDataConfig);
        },
        showImportantDisclosure() {
            return !this.slice.primary.hide_important_disclosure;
        },
        amountFromSlice() {
            return this.slice.primary.amount ? parseInt(this.slice.primary.amount) : null;
        }
    },
    methods: {
        showAllLenders() {
            this.showAll = true;
        },
        filterOutNotEnabledLenders(lenders) {
            return lenders
                .filter(lender => this.$validateContentRelationship(lender))
                .map(lender => this.$store.state.lenders[lender.id])
                .filter(lender => lender && lender.data && lender.data.lists_enabled);
        }
    },
};
</script>